import React, { useState, useEffect } from "react";
import "../assets/styles/AnimalWelfareStyles.css";

// SVG Icons as components
const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const XIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const ChevronRightIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

const ArrowRightIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

const HeartIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

const HandshakeIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m11 17 2 2a1 1 0 1 0 3-3"></path>
    <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
    <path d="m21 3 1 11h-2"></path>
    <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path>
    <path d="M3 4h8"></path>
  </svg>
);

const CheckIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5"></path>
  </svg>
);

const GiftIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="4" rx="1"></rect>
    <path d="M12 8v13"></path>
    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
  </svg>
);

const LeafIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path>
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
  </svg>
);

const TargetIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <circle cx="12" cy="12" r="6"></circle>
    <circle cx="12" cy="12" r="2"></circle>
  </svg>
);

const ShieldIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

const MegaphoneIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 11 18-5v12L3 14v-3z"></path>
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path>
  </svg>
);

const ScaleIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
    <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
    <path d="M7 21h10"></path>
    <path d="M12 3v18"></path>
    <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"></path>
  </svg>
);

const UsersIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const ImageIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <path d="m21 15-5-5L5 21"></path>
  </svg>
);

const PlayCircleIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polygon points="10 8 16 12 10 16 10 8"></polygon>
  </svg>
);

const MailIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
  </svg>
);

const MapPinIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const AnimalWelfare = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [showGoodPractice, setShowGoodPractice] = useState(false);

  // Support flow — details are appended to a Google Sheet in the background
  // via a Google Apps Script web app (no payment gateway, no backend server).
  // Paste the deployed /exec URL from Apps Script below.
  const SHEET_ENDPOINT = "https://script.google.com/macros/s/AKfycbx_FHvJX74LhgSIkzYqhAKP9jyhfyQ2hNgz4nEXuuM2xKB8LVVs5YtWKnOVWpMD9-kthg/exec";
  const supportOptions = [
    {
      type: "monthly",
      no: "01",
      label: "Give Monthly",
      icon: HeartIcon,
      desc: "A regular gift that sustains our vegan outreach and animal welfare work all year round.",
      hasAmount: true,
    },
    {
      type: "onetime",
      no: "02",
      label: "One-Time Gift",
      icon: GiftIcon,
      desc: "A single donation toward plant-based nutrition drives and community education.",
      hasAmount: true,
    },
    {
      type: "fundraise",
      no: "03",
      label: "Fundraise For Us",
      icon: MegaphoneIcon,
      desc: "Rally your friends, school, or community to raise support for animals in Uganda.",
      hasAmount: false,
    },
    {
      type: "corporate",
      no: "04",
      label: "Corporate Partnership",
      icon: HandshakeIcon,
      desc: "Partner your business with our mission through funding, expertise, or in-kind support.",
      hasAmount: false,
    },
  ];

  const [donateType, setDonateType] = useState(null); // active option or null
  const [donorForm, setDonorForm] = useState({ name: "", email: "", phone: "", amount: "", message: "" });
  const [donateSent, setDonateSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const openDonate = (type) => {
    setDonateType(type);
    setDonateSent(false);
    setSubmitError(false);
    setDonorForm({ name: "", email: "", phone: "", amount: "", message: "" });
  };
  const closeDonate = () => setDonateType(null);

  const activeOption = supportOptions.find((o) => o.type === donateType) || null;

  const handleDonorChange = (e) => {
    const { name, value } = e.target;
    setDonorForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDonateSubmit = async (e) => {
    e.preventDefault();
    if (!activeOption || submitting) return;
    setSubmitting(true);
    setSubmitError(false);
    try {
      // text/plain avoids a CORS preflight against the Apps Script endpoint
      const res = await fetch(SHEET_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({
          option: activeOption.label,
          name: donorForm.name,
          email: donorForm.email,
          phone: donorForm.phone,
          amount: donorForm.amount,
          message: donorForm.message,
        }),
      });
      const data = await res.json();
      if (data.result === "success") {
        setDonateSent(true);
      } else {
        setSubmitError(true);
      }
    } catch {
      setSubmitError(true);
    } finally {
      setSubmitting(false);
    }
  };

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "project", label: "Project", icon: LeafIcon, isPill: true },
    { id: "practices", label: "Our Work" },
    { id: "goals", label: "Goals" },
    { id: "team", label: "Team", icon: UsersIcon },
    { id: "gallery", label: "Gallery", icon: ImageIcon },
    { id: "support", label: "Donate", icon: HeartIcon, isDonate: true },
    { id: "contact", label: "Contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const sections = ["home", "about", "project", "practices", "goals", "objectives", "team", "gallery", "support", "contact"];
      const current = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  const handleVideoPlay = (event) => {
    document.querySelectorAll("video").forEach((video) => {
      if (video !== event.currentTarget) {
        video.pause();
      }
    });
  };

  const strategicGoals = [
    {
      icon: ShieldIcon,
      title: "Improve Animal Welfare and Protection",
      description:
        "Reduce cruelty, neglect, and exploitation of animals by promoting ethical standards, humane alternatives, and stronger animal protection practices.",
    },
    {
      icon: LeafIcon,
      title: "Promote Plant-Based Protein Systems",
      description:
        "Support the shift from animal-based to plant-based food systems that are healthy, affordable, culturally appropriate, and environmentally sustainable.",
    },
    {
      icon: HeartIcon,
      title: "Remove Animals from Harmful Human Use",
      description:
        "Advocate for and support the reduction and eventual elimination of animals used for food, entertainment, labor, and other exploitative purposes.",
    },
    {
      icon: MegaphoneIcon,
      title: "Strengthen Public Awareness and Advocacy",
      description:
        "Build informed, compassionate communities that understand the ethical, health, and environmental impacts of animal exploitation.",
    },
    {
      icon: ScaleIcon,
      title: "Influence Policy and Systems Change",
      description:
        "Engage policymakers, institutions, and stakeholders to adopt policies that protect animals and support plant-based and animal-free systems.",
    },
  ];

  const objectives = [
    {
      category: "Animal Welfare & Protection",
      icon: ShieldIcon,
      items: [
        "Increase community awareness of animal welfare principles and animal rights",
        "Reduce cases of animal cruelty, abuse, and neglect through education and advocacy",
        "Support humane interventions that prevent suffering rather than prolong animal exploitation",
      ],
    },
    {
      category: "Plant-Based Protein Promotion",
      icon: LeafIcon,
      items: [
        "Promote plant-based protein diets as viable, nutritious, and affordable alternatives",
        "Support farmers and communities to transition toward plant-based crop production",
        "Advocate for inclusion of plant-based nutrition in schools, health facilities, and community programs",
      ],
    },
    {
      category: "Removal of Animals from Food Systems",
      icon: HeartIcon,
      items: [
        "Advocate for reduced reliance on animal agriculture and animal-derived products",
        "Support livelihoods that do not depend on animal exploitation",
        "Promote food systems that are animal-free, climate-resilient, and socially just",
      ],
    },
    {
      category: "Advocacy, Education & Community Engagement",
      icon: UsersIcon,
      items: [
        "Conduct public education campaigns on ethical, health, and environmental costs",
        "Empower youth, women, and community leaders to become advocates",
        "Build partnerships with civil society, academia, and faith-based institutions",
      ],
    },
    {
      category: "Policy & Institutional Engagement",
      icon: ScaleIcon,
      items: [
        "Advocate for stronger animal protection laws and enforcement mechanisms",
        "Promote policies that support plant-based agriculture and food security",
        "Engage authorities to integrate animal welfare into development planning",
      ],
    },
  ];

  const boardMembers = [
    {
      name: "Ssewankambwe Nicholas",
      position: "Founder and Executive Director",
      image: "/images/ceo.jpg",
    },
    {
      name: "Mukwaya James",
      position: "Chairperson",
      image: "/images/mukwaya-james.jpeg",
    },
    {
      name: "Matovu Moses",
      position: "Treasurer",
      image: "/images/finance.jpg",
    },
    {
      name: "Nalubega Prossy",
      position: "Secretary",
      image: "/images/hr.jpg",
    },
    {
      name: "Taylor Quinn",
      position: "Board Member",
      image: "/images/taylor-quinn.jpeg",
    },
  ];

  const staffMembers = [
    {
      name: "Kabiito Emma",
      position: "Head of Communications",
      image: "/images/kabiito-emma.jpeg",
    },
    {
      name: "Namuddu Sylvia",
      position: "Nutrition Officer",
      image: "/images/namuddu-sylvia.jpeg",
    },
    {
      name: "Nassolo Gorreth",
      position: "Outreach Coordinator",
      image: "/images/nassolo-gorreth.jpeg",
    },
  ];

  const plant4LifeEvents = [
    {
      title: "Outreach",
      venue: "Namungona market, Kampala Uganda",
      theme: "Hypertension Awareness Month",
      summary:
        "Voices For Animal Welfare Uganda joined the rest of the world to commemorate the Month of May as Hypertension Awareness Month.",
      description:
        "Through Plant4Life, the team held public awareness events on cardiovascular diseases that can be prevented through eating and adopting plant-based proteins instead of meat and other animal-based proteins with saturated fats that can negatively impact heart health. These campaigns connect healthier people with reduced animal suffering through lower meat consumption.",
      callout:
        "Join us and be part of the team advocating for the adoption of plant-based diets.",
      hashtags: [
        "Adopt plant-based diets",
        "Reduce meat consumption",
        "Reduce animal suffering",
        "Maintain a healthy heart",
      ],
      media: [
        {
          type: "video",
          src: "https://res.cloudinary.com/dn6stpnn2/video/upload/v1781946962/rakaictyhealth/event1.2_qys5ja.mp4",
          title: "Plant4Life awareness in motion",
          caption:
            "Opening media from Namungona market showing the public awareness drive on heart health, plant-based proteins, and reduced animal suffering.",
        },
        {
          type: "video",
          src: "https://res.cloudinary.com/dn6stpnn2/video/upload/v1781946962/rakaictyhealth/event1.1_ynlxiu.mp4",
          title: "Community conversations",
          caption:
            "A field moment from the Plant4Life outreach where the team engaged community members on diet choices and cardiovascular disease prevention.",
        },
        {
          type: "image",
          src: "https://res.cloudinary.com/dn6stpnn2/image/upload/v1781946960/rakaictyhealth/photo1_z8p9vd.jpg",
          title: "Health awareness at Namungona market",
          caption:
            "Event photography documenting the campaign message on plant-based diets and compassionate food systems.",
        },
        {
          type: "image",
          src: "https://res.cloudinary.com/dn6stpnn2/image/upload/v1781946960/rakaictyhealth/photo1.2_cvnpos.jpg",
          title: "Plant4Life public engagement",
          caption:
            "A campaign scene from this outreach connecting community health, heart awareness, and animal welfare advocacy.",
        },
      ],
    },
    {
      title: "Outreach",
      venue: "Katovu Health Centre III, Lwengo District",
      theme: "Plant-Based Nutrition for Maternal Health",
      summary:
        "Promoting healthier families through plant-based nutrition — a community awareness session for mothers attending antenatal care.",
      description:
        "On 15 June, Voices for Animal Welfare Uganda, through the Plant4Life project, held a session for mothers at antenatal care in Katovu Health Centre III, Lwengo District. It focused on the importance of plant-based proteins and vitamin-rich plant foods for maternal health and healthy baby development. Using the health facility's demonstration garden, mothers took part in a practical learning experience on nutritious, locally grown plant-based foods — encouraging diets that improve human health, reduce dependence on animal-based foods, and contribute to less animal suffering.",
      callout:
        "Together, we can build healthier communities while promoting compassion for animals and the environment.",
      hashtags: [
        "Plant4Life",
        "PlantBasedNutrition",
        "MaternalHealth",
        "HealthyPregnancy",
        "NutritionEducation",
        "AnimalWelfare",
        "SustainableLiving",
      ],
      media: [
        {
          type: "video",
          src: "https://res.cloudinary.com/dn6stpnn2/video/upload/v1782203995/rakaictyhealth/023_dp26nz.mp4",
          title: "Nutrition session in motion",
          caption:
            "A field moment from Katovu Health Centre III as the team guides expectant mothers through plant-based nutrition for maternal health.",
        },
        {
          type: "image",
          src: "https://res.cloudinary.com/dn6stpnn2/image/upload/v1782204529/rakaictyhealth/021_a4qtd1.jpg",
          title: "Learning in the demonstration garden",
          caption:
            "Mothers explore locally grown, vitamin-rich plant foods that support a healthy pregnancy and baby development.",
        },
        {
          type: "image",
          src: "https://res.cloudinary.com/dn6stpnn2/image/upload/v1782204577/rakaictyhealth/02_b8y6vv.jpg",
          title: "Plant-based proteins for healthy families",
          caption:
            "Practical guidance on plant-based protein sources that families can easily grow and access in the community.",
        },
      ],
    },
  ];

  const getInitials = (name) =>
    name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .slice(0, 2);

  return (
    <div className="animal-welfare-container">
      {/* Navigation */}
      <nav className={`navbar-animal ${scrolled ? "navbar-scrolled" : ""}`}>
        <div className="navbar-content">
          <div className="navbar-brand" onClick={() => scrollToSection("home")}>
            <img
              src="/animals.jpeg"
              alt="Voices for Animal Welfare"
              className="navbar-logo-img"
            />
            <div className="navbar-brand-text">
              <h1 className="navbar-title">Voices for Animal Welfare Uganda</h1>
              <p className="navbar-subtitle">Uganda</p>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="navbar-links-desktop">
            {navItems.map((item) => {
              const IconComponent = item.icon;
              return (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`nav-link ${
                  activeSection === item.id ? "nav-link-active" : ""
                } ${item.isPill ? "nav-link-current-project" : ""} ${
                  item.isDonate ? "nav-link-donate" : ""
                }`}
              >
                <span className="nav-link-content">
                  {IconComponent && (
                    <span className="nav-link-icon">
                      <IconComponent size={16} />
                    </span>
                  )}
                  <span>{item.label}</span>
                </span>
              </button>
              );
            })}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <XIcon /> : <MenuIcon />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="mobile-menu">
            {navItems.map((item) => {
              const IconComponent = item.icon;
              return (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`mobile-nav-link ${
                  item.isPill ? "mobile-nav-link-current-project" : ""
                } ${item.isDonate ? "mobile-nav-link-donate" : ""}`}
              >
                <span className="nav-link-content">
                  {IconComponent && (
                    <span className="nav-link-icon">
                      <IconComponent size={16} />
                    </span>
                  )}
                  <span>{item.label}</span>
                </span>
              </button>
              );
            })}
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-section-animal">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="container-custom">
            <div className="hero-grid">
              <div className="hero-text" data-aos="fade-right">
                <span className="hero-kicker">Voices for Animal Welfare Uganda</span>
                <h1 className="hero-title">A Vegan World Free from Animal Suffering</h1>
                <p className="hero-description">
                  Advancing animal welfare and promoting compassionate,
                  sustainable, plant-based food systems in Uganda and
                  beyond.
                </p>
                <div className="hero-actions">
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="btn-primary-green"
                  >
                    <span>Get Involved</span>
                    <ArrowRightIcon size={20} />
                  </button>
                  <button
                    onClick={() => scrollToSection("project")}
                    className="btn-secondary-hero"
                  >
                    <LeafIcon size={18} />
                    <span>Plant4Life</span>
                  </button>
                </div>
              </div>
              <div className="hero-image-container" data-aos="fade-left">
                <div className="hero-image-wrapper">
                  <img
                    src="images/hero-image.jpeg"
                    alt="Animal Welfare"
                    className="hero-image"
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/600x400/1b4332/ffffff?text=Animal+Welfare";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section-padding bg-light">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <h2 className="section-title">About Us</h2>
            <div className="title-underline"></div>
          </div>

          <div className="about-cards">
            <div className="about-card" data-aos="fade-up" data-aos-delay="100">
              <div className="about-card-icon">
                <TargetIcon size={32} />
              </div>
              <h3 className="about-card-title">Our Vision</h3>
              <p className="about-card-text">
                A vegan world where animals live free from suffering and
                exploitation, ecosystems are protected, and communities thrive
                through compassionate, sustainable, plant-based food systems.
              </p>
            </div>

            <div className="about-card" data-aos="fade-up" data-aos-delay="200">
              <div className="about-card-icon">
                <HeartIcon size={32} />
              </div>
              <h3 className="about-card-title">Our Mission</h3>
              <p className="about-card-text">
                To advocate for veganism and advance animal welfare, reducing
                animal suffering by advocating for the removal of animals from the
                food system and other harmful human uses, while promoting
                plant-based protein diets, humane alternatives, and community-led
                solutions that protect animals, people, and the environment in
                Uganda and beyond.
              </p>
            </div>

            <div className="about-card" data-aos="fade-up" data-aos-delay="300">
              <div className="about-card-icon">
                <LeafIcon size={32} />
              </div>
              <h3 className="about-card-title">Overall Goal</h3>
              <p className="about-card-text">
                To eliminate animal suffering caused by human food systems and
                practices by accelerating the transition to plant-based diets and
                humane, animal-free livelihoods.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Current Project */}
      <section id="project" className="section-padding project-section">
        <div className="container-custom">
          <div className="project-feature">
            <div className="project-copy" data-aos="fade-right">
              <span className="section-pill">
                <LeafIcon size={16} />
                Current Project
              </span>
              <h2 className="project-title">Plant4Life</h2>
              <p className="project-lead">
                Plant4Life is a project under Voices for Animal Welfare that
                connects public health, compassionate food systems, and reduced
                animal suffering through plant-based diet advocacy.
              </p>
              <p className="project-description">
                The project supports communities to understand how plant-based
                proteins can protect heart health while reducing dependence on
                animal-based foods that contribute to avoidable animal suffering.
              </p>
              <div className="project-actions">
                <button
                  className="btn-project-primary"
                  onClick={() => scrollToSection("gallery")}
                >
                  <ImageIcon size={18} />
                  View Gallery
                </button>
                <button
                  className="btn-project-secondary"
                  onClick={() => scrollToSection("team")}
                >
                  <UsersIcon size={18} />
                  Meet the Team
                </button>
              </div>
            </div>

            <div className="project-panel" data-aos="fade-left">
              <div className="project-panel-header">
                <span>Project Focus</span>
                <HeartIcon size={22} />
              </div>
              <div className="project-focus-grid">
                <div className="project-focus-item">
                  <span className="project-focus-number">01</span>
                  <h3>Heart Health</h3>
                  <p>Promote awareness on preventable cardiovascular disease risks.</p>
                </div>
                <div className="project-focus-item">
                  <span className="project-focus-number">02</span>
                  <h3>Plant Proteins</h3>
                  <p>Encourage practical adoption of plant-based nutrition.</p>
                </div>
                <div className="project-focus-item">
                  <span className="project-focus-number">03</span>
                  <h3>Animal Welfare</h3>
                  <p>Reduce animal suffering by reducing meat consumption.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Animal Practices Comparison */}
      <section id="practices" className="section-padding">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <h2 className="section-title">Understanding Animal Welfare</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              See the difference between harmful practices and humane alternatives
            </p>
          </div>

          {/* Video Comparison */}
          <div className="video-comparison-section" data-aos="fade-up">
            <div className="video-comparison-header">
              <h3 className="comparison-title">
                {showGoodPractice ? "Humane Practices" : "Current Practices That Harm Animals"}
              </h3>
              <button 
                className="switch-video-btn"
                onClick={() => setShowGoodPractice(!showGoodPractice)}
              >
                <XIcon />
                <span>Show {showGoodPractice ? "Current Practices" : "Better Alternatives"}</span>
              </button>
            </div>

            <div className="video-container">
              {!showGoodPractice ? (
                <div className="video-wrapper">
                  <video 
                    key="bad-practice"
                    controls 
                    muted
                    autoPlay
                    loop
                    playsInline
                    onPlay={handleVideoPlay}
                    className="practice-video"
                    poster="https://via.placeholder.com/800x450/d8f3dc/1b4332?text=Caged+Chickens+Video"
                  >
                    <source src="https://res.cloudinary.com/dn6stpnn2/video/upload/e_volume:-100/v1770553346/bad-practice_ljvlfc.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <p className="video-caption">
                    Chickens confined in small cages - a practice that causes immense suffering
                  </p>
                </div>
              ) : (
                <div className="video-wrapper">
                  <video 
                    key="good-practice"
                    controls 
                    muted
                    autoPlay
                    loop
                    playsInline
                    onPlay={handleVideoPlay}
                    className="practice-video"
                    poster="https://via.placeholder.com/800x450/d8f3dc/1b4332?text=Free+Range+Chickens+Video"
                  >
                    <source src="https://res.cloudinary.com/dn6stpnn2/video/upload/e_volume:-100/v1770553343/good-practice_wabvaw.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <p className="video-caption">
                    Free-range chickens living naturally - a humane and sustainable approach
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Animal Suffering Images */}
          <div className="suffering-images-section" data-aos="fade-up">
            <h3 className="subsection-title">The Reality of Animal Confinement</h3>
            <div className="suffering-grid">
              <div className="suffering-card">
                <div className="suffering-image-wrapper">
                  <img 
                    src="/images/chickens-caged.jpg" 
                    alt="Chickens confined in cages"
                    className="suffering-image"
                  />
                </div>
                <div className="suffering-content">
                  <h4 className="suffering-title">Battery Cage Confinement</h4>
                  <p className="suffering-description">
                    Chickens crammed into small wire cages, unable to spread their wings or exhibit natural behaviors. This intensive confinement causes physical and psychological distress.
                  </p>
                </div>
              </div>

              <div className="suffering-card">
                <div className="suffering-image-wrapper">
                  <img 
                    src="images/cattle-kraals.jpg" 
                    alt="Cattle confined in kraals"
                    className="suffering-image"
                  />
                </div>
                <div className="suffering-content">
                  <h4 className="suffering-title">Overcrowded Kraals</h4>
                  <p className="suffering-description">
                    Cattle kept in cramped, unsanitary conditions without adequate space, shelter, or proper nutrition. These practices harm both animal welfare and meat quality.
                  </p>
                </div>
              </div>
            </div>

            <div className="call-to-action-box">
              <HeartIcon size={32} />
              <h4>These Animals Deserve Better</h4>
              <p>
                Join us in advocating for humane treatment and sustainable, plant-based alternatives that protect both animals and our environment.
              </p>
              <button 
                onClick={() => scrollToSection("contact")}
                className="cta-button"
              >
                Take Action Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Strategic Goals */}
      <section id="goals" className="section-padding">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <h2 className="section-title">Strategic Goals</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Our comprehensive approach to creating lasting change for animals
            </p>
          </div>

          <div className="goals-grid">
            {strategicGoals.map((goal, index) => {
              const IconComponent = goal.icon;
              return (
                <div
                  key={index}
                  className="goal-card"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="goal-card-icon-wrapper">
                    <IconComponent size={32} />
                  </div>
                  <h3 className="goal-card-title">{goal.title}</h3>
                  <p className="goal-card-description">{goal.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Objectives */}
      <section id="objectives" className="section-padding bg-light">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <h2 className="section-title">Our Objectives</h2>
            <div className="title-underline"></div>
          </div>

          <div className="objectives-container">
            {objectives.map((obj, index) => {
              const IconComponent = obj.icon;
              return (
                <div
                  key={index}
                  className="objective-card"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="objective-header">
                    <div className="objective-icon">
                      <IconComponent size={24} />
                    </div>
                    <h3 className="objective-title">{obj.category}</h3>
                  </div>
                  <ul className="objective-list">
                    {obj.items.map((item, idx) => (
                      <li key={idx} className="objective-item">
                        <ChevronRightIcon size={18} />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Team */}
      <section id="team" className="section-padding team-section bg-light">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <span className="section-pill centered">
              <UsersIcon size={16} />
              Team
            </span>
            <h2 className="section-title">Board of Directors & Staff</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              The people guiding and implementing Voices for Animal Welfare programs.
            </p>
          </div>

          <div className="team-block" data-aos="fade-up">
            <div className="team-block-heading">
              <h3>Board of Directors</h3>
              <span>Governance</span>
            </div>
            <div className="people-grid">
              {boardMembers.map((member) => (
                <div className="person-card" key={member.name}>
                  <div className="person-image-wrap">
                    {member.image ? (
                      <img
                        src={member.image}
                        alt={member.name}
                        className="person-image"
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                          if (e.currentTarget.nextSibling) {
                            e.currentTarget.nextSibling.style.display = "flex";
                          }
                        }}
                      />
                    ) : null}
                    <div
                      className="person-initials"
                      style={{ display: member.image ? "none" : "flex" }}
                    >
                      {getInitials(member.name)}
                    </div>
                  </div>
                  <div className="person-info">
                    <h4>{member.name}</h4>
                    <p>{member.position}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="team-block" data-aos="fade-up">
            <div className="team-block-heading">
              <h3>Staff</h3>
              <span>Implementation</span>
            </div>
            <div className="people-grid">
              {staffMembers.map((member) => (
                <div className="person-card" key={member.name}>
                  <div className="person-image-wrap">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="person-image"
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                        if (e.currentTarget.nextSibling) {
                          e.currentTarget.nextSibling.style.display = "flex";
                        }
                      }}
                    />
                    <div className="person-initials">
                      {getInitials(member.name)}
                    </div>
                  </div>
                  <div className="person-info">
                    <h4>{member.name}</h4>
                    <p>{member.position}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" className="section-padding gallery-section">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <span className="section-pill centered">
              <ImageIcon size={16} />
              Gallery
            </span>
            <h2 className="section-title">Plant4Life Event Gallery</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Media is grouped by event, with notes explaining the event and each moment captured.
            </p>
          </div>

          {plant4LifeEvents.map((event) => {
            const [featuredMedia, ...otherMedia] = event.media;
            return (
              <article className="event-gallery" key={event.title} data-aos="fade-up">
                <div className="event-intro">
                  <div>
                    <span className="event-kicker">{event.theme}</span>
                    <h3>{event.title}</h3>
                    <p className="event-venue">
                      <MapPinIcon size={16} />
                      {event.venue}
                    </p>
                  </div>
                  <p>{event.summary}</p>
                  <p>{event.description}</p>
                  <p className="event-callout">{event.callout}</p>
                  <div className="event-tags">
                    {event.hashtags.map((tag) => (
                      <span key={tag}>#{tag}</span>
                    ))}
                  </div>
                </div>

                <div className="featured-media-card">
                  <div className="media-frame media-frame-featured">
                    <video controls playsInline preload="metadata" onPlay={handleVideoPlay}>
                      <source src={featuredMedia.src} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <span className="media-type-badge">
                      <PlayCircleIcon size={16} />
                      Video
                    </span>
                  </div>
                  <div className="featured-media-copy">
                    <h4>{featuredMedia.title}</h4>
                    <p>{featuredMedia.caption}</p>
                  </div>
                </div>

                <div className="gallery-grid">
                  {otherMedia.map((media) => (
                    <div className="gallery-card" key={`${event.title}-${media.src}-${media.title}`}>
                      <div className="media-frame">
                        {media.type === "video" ? (
                          <video controls playsInline preload="metadata" onPlay={handleVideoPlay}>
                            <source src={media.src} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img src={media.src} alt={media.title} />
                        )}
                        <span className="media-type-badge">
                          {media.type === "video" ? (
                            <PlayCircleIcon size={16} />
                          ) : (
                            <ImageIcon size={16} />
                          )}
                          {media.type === "video" ? "Video" : "Image"}
                        </span>
                      </div>
                      <div className="gallery-card-copy">
                        <h4>{media.title}</h4>
                        <p>{media.caption}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* Contact Section */}
      <section id="support" className="support-section">
        <div className="container-custom">
          <div className="support-layout">
            <aside className="support-intro" data-aos="fade-up">
              <span className="support-eyebrow">Get Involved</span>
              <h2>
                Ways to
                <br />
                Donate
              </h2>
              <p>
                Every gift and partnership helps us protect animals and grow
                plant-based living across Uganda. Choose the way that fits you
                &mdash; we&apos;ll take care of the rest.
              </p>
            </aside>

            <ol className="support-index">
              {supportOptions.map((opt, i) => {
                const Icon = opt.icon;
                return (
                  <li key={opt.type}>
                    <button
                      type="button"
                      className="support-row"
                      onClick={() => openDonate(opt.type)}
                      data-aos="fade-up"
                      data-aos-delay={i * 70}
                    >
                      <span className="support-no">{opt.no}</span>
                      <span className="support-row-body">
                        <span className="support-row-head">
                          <Icon size={20} />
                          <span className="support-row-title">{opt.label}</span>
                        </span>
                        <span className="support-row-desc">{opt.desc}</span>
                      </span>
                      <span className="support-row-arrow">
                        <ArrowRightIcon size={20} />
                      </span>
                    </button>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </section>

      <section id="contact" className="contact-section">
        <div className="container-custom">
          <div className="section-header" data-aos="fade-up">
            <h2 className="section-title text-white">Contact Us</h2>
            <div className="title-underline bg-white"></div>
          </div>

          <div className="contact-grid">
            <div className="contact-info" data-aos="fade-right">
              <div className="contact-item">
                <div className="contact-icon">
                  <MapPinIcon size={24} />
                </div>
                <div className="contact-details">
                  <h3 className="contact-label">Address</h3>
                  <p className="contact-text">
                    Voices for Animal Welfare Uganda
                    <br />
                    P.O. BOX 223275, Masaka
                    <br />
                    Uganda
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <MailIcon size={24} />
                </div>
                <div className="contact-details">
                  <h3 className="contact-label">Email</h3>
                  <a
                    href="mailto:voicesforanimalwelfare@gmail.com"
                    className="contact-link"
                  >
                    voicesforanimalwelfare@gmail.com
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-cta" data-aos="fade-left">
              <h3 className="cta-title">Get Involved</h3>
              <p className="cta-text">
                Join us in creating a more compassionate world for animals.
                Whether through volunteering, advocacy, or supporting our
                initiatives, every action counts.
              </p>
              <a
                href="mailto:voicesforanimalwelfare@gmail.com"
                className="btn-cta-white"
              >
                Contact Us Today
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Donate */}
      {/* Donation details modal */}
      {activeOption && (
        <div className="donate-modal-overlay" onClick={closeDonate}>
          <div
            className="donate-modal"
            role="dialog"
            aria-modal="true"
            aria-label={activeOption.label}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="donate-modal-close"
              onClick={closeDonate}
              aria-label="Close"
            >
              <XIcon />
            </button>

            {!donateSent ? (
              <>
                <div className="donate-modal-head">
                  <span className="donate-modal-icon">
                    <activeOption.icon size={24} />
                  </span>
                  <div>
                    <span className="donate-modal-kicker">{activeOption.no} / Donate</span>
                    <h3>{activeOption.label}</h3>
                  </div>
                </div>

                <form className="donate-form" onSubmit={handleDonateSubmit}>
                  <div className="donate-form-grid">
                    <label>
                      Full name<span aria-hidden="true"> *</span>
                      <input
                        type="text"
                        name="name"
                        required
                        value={donorForm.name}
                        onChange={handleDonorChange}
                        placeholder="Your name"
                      />
                    </label>
                    <label>
                      Email<span aria-hidden="true"> *</span>
                      <input
                        type="email"
                        name="email"
                        required
                        value={donorForm.email}
                        onChange={handleDonorChange}
                        placeholder="you@example.com"
                      />
                    </label>
                    <label>
                      Phone <span className="optional">optional</span>
                      <input
                        type="tel"
                        name="phone"
                        value={donorForm.phone}
                        onChange={handleDonorChange}
                        placeholder="+256 ..."
                      />
                    </label>
                    {activeOption.hasAmount ? (
                      <label>
                        Amount <span className="optional">optional</span>
                        <input
                          type="text"
                          name="amount"
                          value={donorForm.amount}
                          onChange={handleDonorChange}
                          placeholder={
                            activeOption.type === "monthly"
                              ? "e.g. £20 / month"
                              : "e.g. £50"
                          }
                        />
                      </label>
                    ) : (
                      <label className="donate-form-full">
                        Organisation <span className="optional">optional</span>
                        <input
                          type="text"
                          name="amount"
                          value={donorForm.amount}
                          onChange={handleDonorChange}
                          placeholder={
                            activeOption.type === "corporate"
                              ? "Your company"
                              : "Group / school / community"
                          }
                        />
                      </label>
                    )}
                    <label className="donate-form-full">
                      Message <span className="optional">optional</span>
                      <textarea
                        name="message"
                        rows="2"
                        value={donorForm.message}
                        onChange={handleDonorChange}
                        placeholder="Anything you'd like us to know"
                      />
                    </label>
                  </div>

                  {submitError && (
                    <p className="donate-form-error">
                      Something went wrong. Please try again in a moment.
                    </p>
                  )}

                  <button
                    type="submit"
                    className="btn-support-submit"
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <span className="donate-spinner" aria-hidden="true" />
                        Sending&hellip;
                      </>
                    ) : (
                      <>
                        Submit
                        <ArrowRightIcon size={18} />
                      </>
                    )}
                  </button>
                </form>
              </>
            ) : (
              <div className="donate-thankyou">
                <span className="thankyou-badge">
                  <CheckIcon size={30} />
                </span>
                <span className="thankyou-eyebrow">Details Received</span>
                <h3>Thank you</h3>
                <p>
                  Your details are safely with us. A member of our team will
                  personally reach out to you very soon.
                </p>
                <span className="thankyou-rule" aria-hidden="true" />
                <button
                  type="button"
                  className="btn-support-submit"
                  onClick={closeDonate}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="footer-animal">
        <div className="container-custom">
          <div className="footer-content">
            <div className="footer-brand">
              <img
                src="/animals.jpeg"
                alt="Voices for Animal Welfare"
                className="footer-logo"
              />
              <h3 className="footer-title">Voices for Animal Welfare Uganda</h3>
            </div>
            <p className="footer-description">
              Advancing animal welfare and promoting plant-based food systems
            </p>
            <p className="footer-copyright">
              &copy; {new Date().getFullYear()} Voices for Animal Welfare Uganda. All
              rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AnimalWelfare;
